import PropTypes from 'prop-types';

import outcomeShape from './outcomeShape';

export default PropTypes.shape({
  id: PropTypes.number.isRequired,
  mainPosition: PropTypes.number,
  orderPosition: PropTypes.number,
  outcomes: PropTypes.objectOf(outcomeShape),
  groups: PropTypes.arrayOf(PropTypes.string),
});
